/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-21, 13:11:55
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-21, 13:33:21
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';

// JSX functional component
const MockCard = ({ children }) =>
  <div class="MockCard">
    <div class="card">
      <div class="card__header">
        <h4 class="header__title">&nbsp;</h4>
        <p class="header__category">&nbsp;</p>
      </div>
      <div class="card__content row">
        { children }
        <div class="col-xs-12 col-md-9 content__left-section">

        </div>
        <div class="col-xs-4 col-md-3 content__right-section hide-mobile">

        </div>
      </div>
    </div>
  </div>;

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MockCardOnMyAccount',

  components: {
    MockCard, SmallLoadingSpinner,
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/MockCardOnMyAccount/component.js